 
import styled from '@emotion/styled';
import type { ReactNode } from 'react';
import { Text } from '../atoms/Text';

interface NavTabProps {
  icon: ReactNode;
  label: string;
  active?: boolean;
  onClick: () => void;
  className?: string;
}

const TabButton = styled.button<{ active: boolean }>`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props) => props.theme.spacing(0.625)};
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Label = styled(Text)<{ active: boolean }>`
  font-size: ${(props) => props.theme.typography.captionBold.fontSize};
  font-weight: ${(props) => (props.active ? props.theme.typography.captionBold.fontWeight : props.theme.typography.captionRegular.fontWeight)};
  color: ${(props) => (props.active ? props.theme.colors.secondary[1000] : props.theme.colors.tertiary[1000])};
  text-align: center;
  white-space: nowrap;
`;

export const NavTab = ({ icon, label, active = false, onClick, className }: NavTabProps) => {
  return (
    <TabButton active={active} onClick={onClick} className={className}>
      <IconWrapper>{icon}</IconWrapper>
      <Label variant="caption" weight={active ? 'bold' : 'regular'} active={active}>
        {label}
      </Label>
    </TabButton>
  );
};
